import { render, staticRenderFns } from "./TournamentDetailsCard.vue?vue&type=template&id=31b53f00&"
import script from "./TournamentDetailsCard.vue?vue&type=script&lang=js&"
export * from "./TournamentDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports